import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { sendUserActivityEvent } from '../utils/useractivity';

const usePageView = (pageUrl) => {
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    if (user && user.id && !user.impersonatedBy) {
      sendUserActivityEvent({
        userId: user.id,
        eventType: 'page_view',
        pageUrl: pageUrl || window.location.href,
      });
    }
  }, [user, pageUrl]);
};

export default usePageView;
